import React from "react";
import { LoadingTemplate, ErrorTemplate, InvalidTemplate } from "../../";

var SwitchStatus = function SwitchStatus(props) {
  switch (props.status) {
    case "action_download":
      return props.action_download();

    case "downloading":
      return props.downloading() ? props.downloading() : /*#__PURE__*/React.createElement(LoadingTemplate, {
        text: props.translation ? props.translation.templates ? props.translation.templates.downloading || "Downloading" : "Downloading" : "Downloading"
      });

    case "loading":
      return props.loading() ? props.loading() : /*#__PURE__*/React.createElement(LoadingTemplate, {
        text: props.translation ? props.translation.templates ? props.translation.templates.loading || "Loading" : "Loading" : "Loading"
      });

    case "success":
      return props.success();

    case "error":
      return props.error() ? props.error() : /*#__PURE__*/React.createElement(ErrorTemplate, {
        text: props.translation ? props.translation.templates ? props.translation.templates.error || "Error" : "Error" : "Error"
      });

    default:
      return /*#__PURE__*/React.createElement(InvalidTemplate, null);
  }
};

SwitchStatus.defaultProps = {
  action_download: function action_download() {
    return null;
  },
  downloading: function downloading() {
    return null;
  },
  loading: function loading() {
    return null;
  },
  success: function success() {
    return null;
  },
  error: function error() {
    return null;
  }
};
export { SwitchStatus };